// GraphQL helper for fetching songs by album ID
import { gql } from '@apollo/client'

export const LIST_SONGS_BY_ID = gql`
  query GetAlbumById($albumId: ID!) {
    listAlbums(where: { AND: [{ id: $albumId }] }) {
      data {
        id
        title
        genre {
          id
          genre
        }
        songs {
          id
          songFile
          songTitle
          artist
          album {
            title
          }
        }
        image
        artist
      }
    }
  }
`
